/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Size Chart Accordion
document.addEventListener('DOMContentLoaded', function () {
  console.log('Size Chart Accordion JS loaded');
  const wrappers = document.querySelectorAll('.table-wrapper');
  const accordions = [];
  let lastOpenedAccordion = null;

  wrappers.forEach(function (wrapper, idx) {
    const table = wrapper.querySelector('table');
    if (!table) return;

    const titleCell = table.querySelector('th[class$="chart__title"]');
    if (!titleCell) return;

    const accordion = document.createElement('div');
    accordion.className = 'chart-accordion';

    const header = document.createElement('button');
    header.className = 'chart-accordion__header';
    header.type = 'button';
    header.innerHTML = titleCell.textContent + ' <span class="chart-accordion__icon">+</span>';

    const content = document.createElement('div');
    content.className = 'chart-accordion__content';
    content.style.maxHeight = '0';
    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)';

    content.appendChild(table);

    accordion.appendChild(header);
    accordion.appendChild(content);
    wrapper.parentNode.insertBefore(accordion, wrapper);
    wrapper.remove();

    accordions.push({ header, content });

    header.addEventListener('click', function () {
      // Close last opened accordion if it's not this one
      if (lastOpenedAccordion && lastOpenedAccordion !== content) {
        lastOpenedAccordion.style.maxHeight = '0';
        lastOpenedAccordion.previousSibling.querySelector('.chart-accordion__icon').textContent = '+';
      }
      const isOpen = content.style.maxHeight !== '0px' && content.style.maxHeight !== '';
      if (isOpen) {
        content.style.maxHeight = '0';
        header.querySelector('.chart-accordion__icon').textContent = '+';
        lastOpenedAccordion = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        header.querySelector('.chart-accordion__icon').textContent = '−';
        lastOpenedAccordion = content;
      }
    });
  });

  // Preopen the last accordion after all are created
  if (accordions.length > 0) {
    const last = accordions[accordions.length - 1];
    last.content.style.maxHeight = last.content.scrollHeight + 'px';
    last.header.querySelector('.chart-accordion__icon').textContent = '−';
    lastOpenedAccordion = last.content;
  }
});

// Brand Navigation Scroll [Ron] [ Size-chart.liquid ]
document.addEventListener('DOMContentLoaded', function () {
  console.log('Brand Navigation Scroll loaded');
  
  const brandButtons = document.querySelectorAll('[data-scroll-target]');
  
  brandButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.getAttribute('data-scroll-target');
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // Close any currently opened accordion first
        const currentlyOpenAccordion = document.querySelector('.chart-accordion__content[style*="max-height"][style*="px"]:not([style*="0px"])');
        if (currentlyOpenAccordion) {
          const currentHeader = currentlyOpenAccordion.previousElementSibling;
          if (currentHeader && currentHeader.classList.contains('chart-accordion__header')) {
            currentlyOpenAccordion.style.maxHeight = '0';
            currentHeader.querySelector('.chart-accordion__icon').textContent = '+';
          }
        }

        // Get element position and subtract offset for sticky nav
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - 270; // 270px offset for sticky nav

        // Smooth scroll to target with offset
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        // Add highlight effect
        targetElement.style.transition = 'background-color 0.3s ease';
        targetElement.style.backgroundColor = 'rgba(255, 103, 0, 0.1)';
        
        setTimeout(() => {
          targetElement.style.backgroundColor = '';
        }, 2000);

        // Find and open the corresponding accordion
        setTimeout(() => {
          // Look for the next accordion after the target element
          let nextElement = targetElement.nextElementSibling;
          let accordionHeader = null;
          
          // Search for the accordion in the next few siblings
          while (nextElement && !accordionHeader) {
            if (nextElement.classList.contains('chart-accordion')) {
              accordionHeader = nextElement.querySelector('.chart-accordion__header');
              break;
            } else if (nextElement.querySelector('.chart-accordion__header')) {
              accordionHeader = nextElement.querySelector('.chart-accordion__header');
              break;
            }
            nextElement = nextElement.nextElementSibling;
          }
          
          // If found, open the accordion
          if (accordionHeader) {
            const content = accordionHeader.nextElementSibling;
            const isOpen = content.style.maxHeight !== '0px' && content.style.maxHeight !== '';
            
            // Only open if it's currently closed
            if (!isOpen) {
              accordionHeader.click();
            }
          }
        }, 500);
      }
    });
  });
});

// Header backdrop-filter on scroll (jQuery)
$(document).ready(function() {
    var $header = $('.header');
    if ($header.length === 0) return;

    $(window).on('scroll', function() {
        var currentScrollTop = $(window).scrollTop();
        
        if (currentScrollTop > 50) {
            $header.css('cssText', 'backdrop-filter: blur(10px) !important; -webkit-backdrop-filter: blur(10px) !important; background-color: rgba(17, 17, 17, .5) !important;');
            $header.css('z-index', '200');
        } else {
            $header.css('cssText', '');
            $header.css('z-index', '');
        }
    });
});
